import { FormState, FormSubmission } from "@episerver/forms-sdk";
import getFieldKeybyDisplayName from "./getFieldKeyByDisplayName";

const GOOGLE_RECAPTCHA_FIELD = 'GoogleRecaptcha';
const DONATION_AMOUNT_FIELD = 'DonationAmount';
const SKIP_VALIDATION_TEXT = 'skip-captcha-validation';

const validateRecaptchaThreshold = (formContext: FormState | null, formSubmission: FormSubmission[], recaptchaThreshold: number = 0 ) => {
    if(!formContext) {
        return formSubmission;
    }

    const recaptchaFieldKey = getFieldKeybyDisplayName(formContext, GOOGLE_RECAPTCHA_FIELD);
    const amountFieldKey = getFieldKeybyDisplayName(formContext, DONATION_AMOUNT_FIELD);
    const transactionAmount = parseFloat(formSubmission.find((submission) => submission.elementKey === amountFieldKey)?.value || '0');

    const recaptchaSubmission = formSubmission.find((submission) => submission.elementKey === recaptchaFieldKey);

    /**
     * If the transaction amount is greater than the threshold,
     * we skip the recaptcha validation by sending static string to backend
     */
    if(recaptchaSubmission && transactionAmount >= recaptchaThreshold) {
        recaptchaSubmission.value = SKIP_VALIDATION_TEXT;

        formSubmission.map((submission) => {
            if(submission.elementKey === recaptchaFieldKey) {
                return recaptchaSubmission;
            }
            return submission;
        });
    }

    return formSubmission;
};

export default validateRecaptchaThreshold;
